import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core'
import { Router } from '@angular/router';

@Component({
	selector: 'app-ice-tabs',
	templateUrl: './ice-tabs.component.html',
	styleUrls: ['./ice-tabs.component.scss'],
})
export class IceTabsComponent implements OnInit {
	@Input() data: any = {}
    @Input() lang: string = ''
	@Input() dataDictionary: any = {}
    @Output() openModal: EventEmitter<{ showModal: boolean, name: string }> = new EventEmitter();
	constructor(private router: Router) {}
    onClick(event: any, name:string) {
        event.preventDefault();
        this.openModal.emit({ showModal: true, name: name });
    }
	hasButton = true
	ngOnInit(): void {
		const url = this.router.url;
		if (!url.includes('maquinas-de-gelo')) {
			this.hasButton = false
		} 
	}
}
